// extracted by mini-css-extract-plugin
module.exports = {"thumb-vertical":"thumb-vertical"};